import moment from 'moment';

import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';

import * as Api from '../../../api/api';

export const endSurvey = (surveyId: number) =>
  createGenericDispatcher<Survey>({
    name: 'END_SURVEY',
    loadFunction: () =>
      Api.post(`/surveys/${surveyId}`, {
        body: JSON.stringify({
          endAt: moment.utc(),
          endMethod: 'MANUALLY',
        }),
      }),
    args: { surveyId },
  });
